class CartDrawerGiftWidget extends HTMLElement {
  constructor() {
    super();
    this.sectionsToRender = [
      {
        section_id: 'cart-drawer',
        selectors: ['.drawer__header', 'cart-drawer-items', '.drawer__footer'],
      },
      {
        section_id: 'cart-icon-bubble',
        selectors: ['.cart-count-bubble'],
      },
    ];
  }

  connectedCallback() {
    this.initSwiper();
    this.attachEventListeners();
  }

  initSwiper() {
    const swiperElement = this.querySelector('.free-samples__slider.swiper');
    if (!swiperElement || swiperElement.dataset.isLoaded === 'true' || typeof Swiper === 'undefined') return;
    new Swiper(swiperElement, {
      loop: false,
      slidesPerView: 2.33,
      spaceBetween: 10,
    });
    swiperElement.dataset.isLoaded = 'true';
  }

  attachEventListeners() {
    // Slide click (add/remove sample)
    this.querySelectorAll('.free-samples__slide').forEach((slide) => {
      slide.addEventListener('click', (e) => this.handleSampleWidgetClick(e));
    });
    // Navigation arrows
    this.querySelector('.navigation_arrows .--arrow_prev')?.addEventListener('click', () =>
      this.handleSampleNavigation('prev')
    );
    this.querySelector('.navigation_arrows .--arrow_next')?.addEventListener('click', () =>
      this.handleSampleNavigation('next')
    );
    // Dots
    this.querySelectorAll('.control__dot').forEach((dot) => {
      dot.addEventListener('click', (e) => this.handleSampleNavigation(parseInt(dot.dataset.dotIndex)));
    });
    // Expand/collapse
    this.querySelector('[data-widget-expand]')?.addEventListener('click', () => {
      this.toggleExpandedFreeSample();
    });
  }

  toggleExpandedFreeSample() {
    this.querySelector('.free-samples__container').classList.toggle('--collapsed');
  }

  async handleSampleWidgetClick(e) {
    const slide = e.currentTarget;
    if (slide.hasAttribute("data-disabled")) return;
    const container = this;
    try {
      container.classList.add('--blocked');
      const variantId = slide.dataset?.variantId;
      const lineItemKey = slide.dataset?.lineItemKey ?? null;
      const isSelected = slide.classList.contains('--selected');
      const promoType = slide.dataset?.promoType ?? null;
      const promoDisplayName = slide.dataset?.promoDisplayName ?? '';
      if (!promoType || typeof promoType !== 'string') throw new Error('Promo Type not defined or not string');
      const properties = { _free_item_type: promoDisplayName };
      if (promoType === 'free-gift') {
        const promoHandle = slide.dataset.promoHandle;
        properties['_gwp_promo'] = promoHandle;
      }
      if (isSelected && lineItemKey) {
        await this.cartRemoveItem(lineItemKey);
      } else {
        await this.cartAddItem(variantId, 1, properties);
      }
    } catch (err) {
      console.error(err);
    }
  }

  handleSampleNavigation(index) {
    const slider = this.querySelector('.free-samples__slider');
    const total_slides = slider.querySelectorAll('.free-samples__slide').length;
    const current_index = parseInt(slider.dataset.currentIndex);
    let next_index = null;
    if (index === 'next') {
      next_index = current_index + 1;
      const nextSlide = slider.querySelector(`.free-samples__slide[data-slider-index="${next_index}"]`);
      if (!nextSlide) return;
      slider.setAttribute('data-current-index', next_index);
    } else if (index == 'prev') {
      next_index = current_index - 1;
      const prevSlide = slider.querySelector(`.free-samples__slide[data-slider-index="${next_index}"]`);
      if (prevSlide) {
        slider.setAttribute('data-current-index', next_index);
      }
    } else {
      next_index = index;
      const slide = slider.querySelector(`.free-samples__slide[data-slider-index="${index}"]`);
      if (slide) {
        slider.setAttribute('data-current-index', index);
      }
    }
    // update the navigation buttons
    const prevButton = this.querySelector('.navigation_arrows .--arrow_prev');
    const nextButton = this.querySelector('.navigation_arrows .--arrow_next');
    if (next_index == 1) {
      prevButton.setAttribute('disabled', 'disabled');
    } else {
      prevButton.removeAttribute('disabled');
    }
    if (next_index == total_slides) {
      nextButton.setAttribute('disabled', 'disabled');
    } else {
      nextButton.removeAttribute('disabled');
    }

    // update dots
    const dots = this.querySelectorAll('.control__dot');
    dots.forEach((dot) => {
      const dotIndex = parseInt(dot.dataset.dotIndex);
      if (dotIndex == next_index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    // update pagination
    const currentPage = this.querySelector('.current_page');
    if (currentPage) {
      currentPage.textContent = next_index;
    }

    const swiper = this.querySelector('.free-samples__slider.swiper')?.swiper;
    if (swiper) {
      if (index === 'next') {
        swiper.slideNext();
      } else if (index === 'prev') {
        swiper.slidePrev();
      } else {
        swiper.slideTo(index - 1);
      }
    }
  }

  async cartAddItem(variantId, quantity, properties = {}) {
    try {
      const body = JSON.stringify({
        items: [{ id: variantId, quantity, properties }],
        sections: this.sectionsToRender.map((section) => section.section_id),
      });
      const response = await fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } });
      const data = await response.json();
      await this.updateLiveContent(data.sections);
    } catch (e) {
      console.error(e);
    }
  }

  async cartRemoveItem(lineItemKey) {
    try {
      const body = JSON.stringify({
        id: lineItemKey,
        quantity: '0',
        sections: this.sectionsToRender.map((section) => section.section_id),
      });
      const response = await fetch(routes.cart_change_url, { ...fetchConfig(), ...{ body } });
      const data = await response.json();
      await this.updateLiveContent(data.sections);
    } catch (e) {
      console.error(e);
    }
  }

  async updateLiveContent(updatedSections) {
    try {
      const swiperInstance = this.querySelector('.free-samples__slider.swiper')?.swiper;
      const activeIndex = swiperInstance?.activeIndex || 0;

      for (const section of this.sectionsToRender) {
        const content = updatedSections[section.section_id];
        const html = new DOMParser().parseFromString(content, 'text/html');
        section.selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        });
      }

      setTimeout(() => {
        const newSwiper = this.querySelector('.free-samples__slider.swiper')?.swiper;
        if (newSwiper) {
          newSwiper.slideTo(activeIndex, 0);
          this.handleSampleNavigation(activeIndex + 1);

          const currentPage = this.querySelector('.current_page');
          if (currentPage) {
            currentPage.textContent = (activeIndex + 1).toString();
          }

          const dots = this.querySelectorAll('.control__dot');
          dots.forEach((dot) => {
            const dotIndex = parseInt(dot.dataset.dotIndex);
            if (dotIndex === activeIndex + 1) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }
      }, 0);
    } catch (e) {
      console.error(e);
    }
  }
}

customElements.define('cart-drawer-gift-widget', CartDrawerGiftWidget);
